import { Variables } from 'react-relay';
import { MockResponseConfig } from '../getMockResponse';
import { mockFullLoggedInUser } from './mockFullLoggedInUser';

export const mockFullLoggedInUserVisitingPrivateProfile: MockResponseConfig = {
  ...mockFullLoggedInUser,
  UnifiedProfileQuery: (variables: Variables) => ({
    data: {
      unified: {
        unifiedProfile: {
          ...mockFullLoggedInUser.UnifiedProfileQuery(variables).data.unified
            .unifiedProfile,
          username: 'privateprofile',
          isPrivate: true,
          isPersonalView: false,
          isLinkedView: false,
        },
      },
    },
  }),
  AtlassianAccountUserQuery: (variables: Variables) => ({
    data: {
      me: {
        user: {
          ...mockFullLoggedInUser.AtlassianAccountUserQuery(variables).data.me
            .user,
          accountId: null,
        },
      },
    },
  }),
};
